import { useRef } from 'react';

import ErrorPayment from 'components/Patient/checkin/SecurePayment/ErrorPayment';

import { usePaymentContextApi } from '../context/PaymentContext';

const ErrorPaymentModal = ({
  message,
  description,
  title,
  isOpen = true,
  onClearError = () => {},
  onClose = () => {},
  onTryAgain
}) => {
  const { closeModal } = usePaymentContextApi();

  const handleClearError = () => {
    closeModal();
    onClearError(null);
    onClose();
  };

  const isRetryingRef = useRef(false);

  const handleTryAgain = async () => {
    if (isRetryingRef.current) return;
    isRetryingRef.current = true;
    onClearError(null);
    try {
      await onTryAgain?.();
    } finally {
      isRetryingRef.current = false;
    }
  };

  return (
    <ErrorPayment
      isOpen={isOpen}
      message={message}
      description={description}
      title={title}
      onTryAgain={handleTryAgain}
      onClose={handleClearError}
    />
  );
};

export default ErrorPaymentModal;
